/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { HealthCheckActionResponseDto, PingResponseDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class ApiClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags Health
   * @name HealthGet
   * @summary Gets a the information for the health check.
   * @request GET:/api/health
   */
  healthGet = (
    query?: {
      /**
       * Skip database connectivity.
       * @default true
       */
      skipDatabaseConnectivity?: boolean;
      /**
       * Skip redis connectivity.
       * @default true
       */
      skipRedisConnectivity?: boolean;
      /**
       * Skip package information.
       * @default true
       */
      skipPackageInformation?: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<HealthCheckActionResponseDto, any>({
      path: `/api/health`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Ping
   * @name PingPing
   * @request GET:/api/ping
   */
  pingPing = (params: RequestParams = {}) =>
    this.http.request<PingResponseDto, any>({
      path: `/api/ping`,
      method: "GET",
      format: "json",
      ...params,
    });
}
